module.exports = __webpack_public_path__ + "static/media/bird.bbfa6ffc.svg";